import React from "react";

function SvgText(props) {
  let blur = "";
  if (props.activeMove) {
    blur = "40";
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 166.94 210.489"
    >
      <g
        id="Group_6664"
        data-name="Group 6664"
        transform="translate(-1897 -9225.511)"
      >
        <g id="file" transform="translate(1825 9201.511)">
          <path
            id="Path_16489"
            data-name="Path 16489"
            d="M217.165,234.489H93.775A21.775,21.775,0,0,1,72,212.714V45.775A21.775,21.775,0,0,1,93.775,24H195.39L238.94,67.549V212.714A21.775,21.775,0,0,1,217.165,234.489Z"
            fill={"#cfd2fc"+blur}
          />
          <path
            id="Path_16490"
            data-name="Path 16490"
            d="M72,360H238.94v36.291a21.775,21.775,0,0,1-21.775,21.775H93.775A21.775,21.775,0,0,1,72,396.291Z"
            transform="translate(0 -183.577)"
            fill={"#cfd2fc"+blur}
          />
          <g
            id="Group_6663"
            data-name="Group 6663"
            transform="translate(97.404 24)"
          >
            <path
              id="Path_16491"
              data-name="Path 16491"
              d="M387.55,67.549H365.775A21.775,21.775,0,0,1,344,45.775V24Z"
              transform="translate(-246.014 -24)"
              fill="#8690fa"
            />
            <path
              id="Path_16492"
              data-name="Path 16492"
              d="M240.5,199.258H131.629a3.629,3.629,0,0,1,0-7.258H240.5a3.629,3.629,0,1,1,0,7.258Z"
              transform="translate(-128 -115.788)"
              fill="#8690fa"
            />
            <path
              id="Path_16493"
              data-name="Path 16493"
              d="M240.5,231.258H131.629a3.629,3.629,0,0,1,0-7.258H240.5a3.629,3.629,0,1,1,0,7.258Z"
              transform="translate(-128 -133.272)"
              fill="#8690fa"
            />
            <path
              id="Path_16494"
              data-name="Path 16494"
              d="M240.5,263.258H131.629a3.629,3.629,0,1,1,0-7.258H240.5a3.629,3.629,0,0,1,0,7.258Z"
              transform="translate(-128 -150.755)"
              fill="#8690fa"
            />
            <path
              id="Path_16495"
              data-name="Path 16495"
              d="M240.5,167.258H131.629a3.629,3.629,0,0,1,0-7.258H240.5a3.629,3.629,0,0,1,0,7.258Z"
              transform="translate(-128 -98.305)"
              fill="#8690fa"
            />
            <path
              id="Path_16496"
              data-name="Path 16496"
              d="M218.728,295.258h-87.1a3.629,3.629,0,1,1,0-7.258h87.1a3.629,3.629,0,1,1,0,7.258Z"
              transform="translate(-128 -168.239)"
              fill="#8690fa"
            />
            <path
              id="Path_16497"
              data-name="Path 16497"
              d="M164.291,135.258H131.629a3.629,3.629,0,0,1,0-7.258h32.662a3.629,3.629,0,0,1,0,7.258Z"
              transform="translate(-128 -80.821)"
              fill="#8690fa"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgText);
